module.exports = __webpack_public_path__ + "img/rflex.bdd66471.png";